// for add employee

export const RESET_TASK_LIST = "reset_task_list";
export const TASK_LIST = "task_list";
export const ADD_TASK = "add_task";
export const EDIT_TASK = "edit_task";
export const DELETE_TASK = "delete_task";
